import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { Models } from './index';
import { ICaseStudyItem } from '../components/case-study-list/case-study-list-item/case-study-article-list-item';
import { ICaseStudyListProps } from '../components/case-study-list/case-study-list-types';

export class CaseStudyListModel extends ContentItem {
  get buttonText(): string {
    return get(this._config, 'elements.button_text.value', '');
  }

  get articles(): ICaseStudyItem[] {
    const nodes = get(this._config, 'nodes', []);
    const modeledArticles = nodes.map((article: ICaseStudyListItem) =>
      Models.CaseStudyListItemModel.create(article)
    );

    return modeledArticles;
  }

  get totalCount(): number {
    return get(this._config, 'totalCount', 0);
  }

  get industryCategoryText(): string {
    return get(this._config, 'elements.industry_category_text.value', '');
  }

  get projectCategoryText(): string {
    return get(this._config, 'elements.project_category_text.value', '');
  }

  get technologyCategoryText(): string {
    return get(this._config, 'elements.technology_category_text.value', '');
  }

  get countryCategoryText(): string {
    return get(this._config, 'elements.country_category_text.value', '');
  }

  public static create(data: ICaseStudyData): ICaseStudyListProps {
    const {
      buttonText,
      articles,
      totalCount,
      industryCategoryText,
      projectCategoryText,
      technologyCategoryText,
      countryCategoryText
    } = new CaseStudyListModel(data);

    return {
      buttonText,
      articles,
      totalCount,
      industryCategoryText,
      projectCategoryText,
      technologyCategoryText,
      countryCategoryText
    };
  }
}
